export default "__VITE_ASSET__CFvAhFkh__"